import { useSearchParams } from "react-router-dom";
import {
  useGetVideosQuery,
  useGetVideoQuery,
} from "@features/videos/videosApi";
import Description from "@student/components/Course/Description";
import CourseList from "@student/components/Course/Sidebar/CourseList";
import VideoPlayer from "@student/components/Course/VideoPlayer";

const CoursePlayer = () => {
  const [searchParams] = useSearchParams();

  const id = searchParams.get("id") || "";

  const { data: videos, isLoading } = useGetVideosQuery();

  const { data: video, isLoading: videoLoading } = useGetVideoQuery(id) || {};

  return (
    <div className="grid grid-cols-3 gap-2 lg:gap-8">
      {(isLoading || videoLoading) && (
        <div className="col-span-full w-full space-y-8 lg:col-span-2">
          Loading...
        </div>
      )}

      {(!video || !videos) && !isLoading && (
        <div className="col-span-full w-full space-y-8 lg:col-span-2">
          Video not found!
        </div>
      )}

      {(video?.id || videos?.length > 0) && (
        <div className="col-span-full w-full space-y-8 lg:col-span-2">
          <VideoPlayer
            video={id ? video : videos?.length > 0 ? videos[0] : {}}
          />
          <Description video={id ? video : videos?.length > 0 && videos[0]} />
        </div>
      )}

      <CourseList />
    </div>
  );
};

export default CoursePlayer;
